<template>
    <div v-if="visible" class="status-wrapper" :class="$route.name === 'login' ? 'login' : ''">
        <div
            v-if="small"
            :style="{ backgroundColor: ledStatus ? '#237723' : '#D2222D' }"
            class="led-container"
        />
        <div v-else>
            <v-chip closable :color="ledStatus ? 'success' : 'error'" label size="x-small">
                <template #prepend>
                    <CloudIcon v-if="ledStatus" size="12" class="mr-1" />
                    <CloudOffIcon v-else size="12" class="mr-1" />
                </template>
                {{ ledStatus ? 'Online' : 'Offline' }}
            </v-chip>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { mainAxios as axios } from '@/assets/js/axios_config';
import { CloudIcon, CloudOffIcon } from 'lucide-vue-next';
const props = defineProps({
    small: {
        type: Boolean,
        default: false,
    },
});

const route = useRoute();
const ledStatus = ref(false);
const visible = ref(false);

const checkBackendStatus = async () => {
    try {
        await axios.get('/oapi/live');
        ledStatus.value = true;
    } catch (error) {
        ledStatus.value = false;
    }
};

onMounted(() => {
    // if address is test.respeak.io or localhost check the backend live status
    if (
        window.location.hostname === 'localhost' ||
        window.location.hostname === 'expert-test.respeak.io'
    ) {
        visible.value = true;
        checkBackendStatus();
    }
});
</script>

<style scoped lang="scss">
.status-wrapper {
    position: fixed;
    display: flex;
    align-items: center;
    gap: 0.25rem;
    top: 2px;
    right: 2px;
    font-size: 12px;

    z-index: 1000;

    &.login {
        top: 33px !important;
        left: 162px !important;

        .v-chip {
            color: #fff !important;

            .text-success {
                color: #fff !important;
            }
        }
    }
}

.led-container {
    width: 12px;
    height: 12px;

    margin-bottom: 1px;

    border-radius: 50%;
}
</style>
